// Entradas al hacer scroll. Sin librerías: con IntersectionObserver y dos
// propiedades CSS sobra, y cualquier librería de animación pesa más que toda
// la hoja de estilos junta.
//
// Solo se animan transform y opacity, que el navegador resuelve en la GPU sin
// recalcular el diseño. Animar height o top fuerza un reflow por fotograma y es
// exactamente lo que hacía que el sitio anterior fuese a tirones en móvil.

// Si el usuario ha pedido menos movimiento, no se observa nada: el CSS ya deja
// los elementos visibles, así que quitar la clase es suficiente.
// La PRIMERA PANTALLA queda deliberadamente fuera. Dos motivos, y el segundo lo
// descubrí midiendo: (1) es donde se toma la decisión de compra y nada debe
// retrasar el botón; (2) translateY(16px) desplaza el bloque hacia abajo durante
// la animación, y en 375x667 eso empujaba los iconos de confianza fuera de
// pantalla justo mientras el usuario aterrizaba. Una animación de entrada no
// puede decidir si la primera pantalla cabe.
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  // Dos formas de entrar: los hijos directos de una sección normal, y cualquier
  // contenedor marcado con data-aparece. Lo segundo hace falta para los bloques
  // que no siguen el patrón .seccion > .contenedor (la crema flotando, por
  // ejemplo) sin tener que envolverlos en marcado que no aporta nada.
  // :not([aria-hidden="true"]) excluye los elementos decorativos, y no es un
  // detalle de estilo: la clase .aparece termina en `filter: none`, así que si
  // entrara un orbe —que ES un filter: blur(70px)— la animación le borraría el
  // desenfoque al acabar y dejaría un círculo de color con el borde a cuchillo.
  // Además, animar la entrada de algo que un lector de pantalla ni anuncia no
  // tiene ningún sentido.
  const objetivos = document.querySelectorAll(
    '.seccion > .contenedor > *:not([aria-hidden="true"]), ' +
    '[data-aparece] > *:not([aria-hidden="true"])'
  );

  objetivos.forEach(el => el.classList.add('aparece'));

  const observador = new IntersectionObserver((entradas) => {
    for (const entrada of entradas) {
      if (!entrada.isIntersecting) continue;
      entrada.target.classList.add('visible');
      // Se deja de observar en cuanto aparece: mantener vivos decenas de
      // observadores para elementos ya visibles no aporta nada y cuesta.
      observador.unobserve(entrada.target);
      // will-change se quita al acabar. Dejarlo puesto obliga al navegador a
      // mantener una capa por elemento y en móvil eso se nota en la memoria.
      entrada.target.addEventListener('transitionend', () => {
        entrada.target.style.willChange = 'auto';
      }, { once: true });
    }
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  objetivos.forEach(el => observador.observe(el));
}
